'use client';
import { useEffect, useRef } from 'react';
import drawPizza from '@/lib/visualisers/pizza';

interface FractionPizzaProps {
    numerator: number;
    denominator: number;
    color: string;
}

export default function FractionPizza({ numerator, denominator, color }: FractionPizzaProps) {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const c = canvasRef.current;
        if (!c) return;
        if (typeof drawPizza === 'function') {
            drawPizza(c, { numerator, denominator, size: 400, radius: 150, highlightColor: color });
        }
    }, [numerator, denominator, color]);

    const n = Number.isFinite(numerator) ? numerator : 0;
    const d = Math.max(1, Number.isFinite(denominator) ? denominator : 1);

    return (
        <div className="flex w-full max-w-[400px] flex-col items-center rounded-lg border-[0.5px] border-line bg-white p-5">
            <canvas
                ref={canvasRef}
                aria-label={`${n}/${d} of the pizza is highlighted`}
                className="h-auto w-full"
            />
        </div>
    );
}
